/**
 * 
 * key
 * 
 */


const key = 'cHJpbnRQbFByaW50UGVuZGluZw=='

export default key 